import { IGif } from '@giphy/js-types'
import { getFirstPathSegment, getPageOptionsBasedOnPath, PageOptions } from './utils/page'
import { getSiteOptions, SiteOptions } from './utils/site'

declare global {
    interface Window {
        user?: UserOptions
        creator?: CreatorOptions
        GTM_CONTAINER_ID: string
        CURRENT_VERSION: string
        dataLayer: any[]
    }
}

export interface ContentOptions {
    contentId: string
    contentType: string
}

export interface CreatorOptions {
    creatorName?: string
    creatorId?: string
}

export interface UserOptions {
    loggedInStatus: boolean
    userType?: 'user' | 'staff' | 'artist' | ''
    verifiedStatus?: boolean
    userID?: string
    loginMethod?: string
}

export interface GAEventData {
    event?: string
    site?: SiteOptions
    page?: PageOptions
    user?: UserOptions
    creator?: CreatorOptions
    [key: string]: any
}

export const setCreator = (creator: CreatorOptions) => {
    if (typeof window !== 'undefined') {
        window.creator = creator
    }
}

export const getCreator = (): CreatorOptions => {
    if (window.creator) return window.creator

    return {
        creatorId: '',
        creatorName: '',
    }
}

export const getContentOfGif = (gif: IGif) => {
    if (gif.is_sticker) {
        return {
            contentId: gif.id,
            contentType: 'sticker',
        }
    }

    return {
        contentId: gif.id,
        contentType: gif.type,
    }
}

export const getCreatorOfGif = (gif: IGif) => ({
    creatorName: gif?.user?.display_name || gif?.user?.username,
    creatorId: gif?.user?.id,
})

export const setUser = (user: UserOptions) => {
    window.user = user
}

export const getUser = (): UserOptions => {
    if (window.user) return window.user

    return {
        loggedInStatus: false,
        userType: '',
        verifiedStatus: false,
        userID: '',
        loginMethod: '',
    }
}

export const getInitialGADataLayerData = (): GAEventData => ({
    user: { ...getUser() },
    creator: { ...getCreator() },
    site: { ...getSiteOptions() },
    page: { ...getPageOptionsBasedOnPath(getFirstPathSegment(window.location.href)) },
})

export const getGADataLayerData = (): GAEventData => ({
    creator: { ...getCreator() },
    site: { ...getSiteOptions() },
    page: { ...getPageOptionsBasedOnPath(getFirstPathSegment(window.location.href)) },
})

export const setGADataLayer = (params?: { event?: string; options?: { [key: string]: any } }) => {
    if (!window.dataLayer) window.dataLayer = []

    const data = getGADataLayerData()

    if (params?.event) {
        data.event = params.event
    }

    window.dataLayer.push({
        ...data,
        ...params?.options,
    })
}

export const getUserLoginParameters = () => {
    if (typeof window == 'undefined') {
        return {
            platform: undefined,
            action: undefined,
        }
    }
    
    const queryParams = new URLSearchParams(window?.location?.search)
    const loginType = queryParams.get('loginType')

    let platform: string | undefined = undefined
    let action: string | undefined = undefined

    if (loginType) {
        const [platformName, actionType] = loginType.split('_')
        platform = platformName
        action = actionType
    }

    return {
        platform,
        action,
    }
}
